import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // `app-shell`: marca que o Layout está montado. O index.css usa essa classe
  // para travar o scroll do documento apenas nas telas internas — as rotas
  // públicas (fora do Layout) precisam que o body role.
  return (
    <div className="app-shell flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Área principal */}
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        {/* Header fixo */}
        <Header onMenuClick={() => setSidebarOpen(true)} />

        {/* Conteúdo das páginas (Dashboard, Automations, etc).
            `min-h-0` é essencial: sem isso, um filho flex com `flex-1` usa
            `min-content` como altura mínima e o `overflow-y-auto` só entra em
            ação após o conteúdo empurrar o layout, permitindo scroll no body.
            `min-w-0` no pai flex evita o mesmo pitfall em largura (tabelas
            com `overflow-x-auto` interno). */}
        <main className="min-h-0 min-w-0 flex-1 overflow-y-auto bg-background p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
